import { Container, Col, Row } from "reactstrap";
import * as PointQL from "queries/point";
import { Link } from "react-router-dom";
import { List } from "@repoflow/components/list-cursor";
import PointSchema from "@common/schema/point/public";
import * as widgets from "widgets/register";
import * as Section from "@repoflow/components/section";

export const Sidebar = () => null;

export const Indice = () => null;

export const Content = ({ match: { params } }) => {
  const { base } = Section.useSectionContext();

  return (
    <Container>
      <div className="mt-4"></div>

      <Row>
        <Col>
          <Link className={"btn btn-primary"} to={`${base}/new`}>
            <i className="fa fa-plus" /> Add
          </Link>
        </Col>
      </Row>

      <div className="mt-4"></div>

      <List
        path={"viewer.account.points"}
        query={PointQL.list}
        variables={params}
        schema={PointSchema}
        widgets={widgets}
        target={{ $ref: "/Public/Point" }}
        empty={"No points yet."}
        config={{
          "/Public/Point": {
            fields: ["pointId", "description", "createdAt"],
          },
        }}
        content={({ item: { pointId } }) => (
          <>
            <Link className={"btn btn-primary"} to={`${base}/${pointId}/`}>
              View
            </Link>{" "}
          </>
        )}
      />
    </Container>
  );
};
